import React, { useEffect, useState } from "react";
import api from "utils/apiService";

import TableDemo from "components/TableDemo";
import { paymentRequestsColumns } from "data/paymentRequestsColumns";
import { useSearchParams } from "react-router-dom";
import ExportSheet from "./components/ExportSheet";

const Index = () => {
  const [data, setData] = useState({ data: [], pagination: { totalDocs: 0 } });

  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || 1;
  const status = searchParams.get("status");
  const search = searchParams.get("search");

  const fetchData = async () => {
    try {
      const res = await api.get(
        `/paymentRequests?page=${page}${
          status
            ? `&status=${status === "accepted" ? "completed" : status}`
            : ""
        }${search ? `&phoneNumber=${search}` : ""}`
      );

      if (res.error) {
        console.error("API Error:", res.error);
      } else {
        setData({
          data: res?.data || [],
          pagination: res?.pagination || { totalDocs: 0 },
        });
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, status, search]);
  return (
    <section className="mt-3">
      <div className="mb-10">
        <TableDemo
          data={data?.data}
          columns={paymentRequestsColumns(fetchData)}
          title="طلبات الدفع"
          totalCount={data?.pagination?.totalDocs}
          loading={loading}
          extraComponent={<ExportSheet />}
        />
      </div>
    </section>
  );
};

export default Index;
